/* eslint-disable max-classes-per-file */

import 'isomorphic-fetch';
import 'regenerator-runtime';

export class NetworkError extends Error {}

class ResponseError extends Error {

    constructor(response, message) {
        super(message);
        this.response = response;
    }

}

export class DecodeError extends ResponseError {}

export class HttpError extends ResponseError {

    constructor(response, data) {
        super(response, response.statusText);
        this.code = response.status;
        this.data = data;
    }

}

const DataHandlers = {
    text: response => response.text(),
    json: response => response.json(),
};

export const getHandler = (response, handlers = DataHandlers) => {
    const contentType = response.headers.get('Content-Type');

    if (contentType === null) throw new DecodeError(response, 'Missing content type header.');

    const [mimeType] = contentType.split('; ');
    const [type, subtype] = mimeType.split('/');
    const handler = handlers[mimeType] || handlers[subtype] || handlers[type] || null;

    if (handler === null) throw new DecodeError(response, `No data handler found for content type ${mimeType}.`);

    return handler;
};

export default async (url, options) => {
    const request = fetch(url, options);

    let response;

    try {
        response = await request;
    } catch (error) {
        throw new NetworkError(error);
    }

    if (response.status === 204) return null;

    const handler = getHandler(response);

    let data;

    try {
        data = await handler(response);
    } catch (error) {
        throw new DecodeError(response, error);
    }

    if (response.ok) return data;

    throw new HttpError(response, data);
};
